var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// @warp-css;
import { html, LitElement, nothing } from 'lit';
import { classNames } from '@chbphone55/classnames';
import { property } from 'lit/decorators.js';
import { reset } from '../styles';
import { styles } from './styles';
/**
 * Box is a layout component used for separating content areas on a page.
 *
 * [See Storybook for usage examples](https://warp-ds.github.io/elements/?path=/docs/layout-box--docs)
 */
class WarpBox extends LitElement {
    // Slotted elements remain in lightDOM which allows for control of their style outside of shadowDOM.
    // ::slotted([Simple Selector]) confirms to Specificity rules, but (being simple) does not add weight to lightDOM skin selectors,
    // so never gets higher Specificity. Thus in order to overwrite style linked within shadowDOM, we need to use !important.
    // https://stackoverflow.com/a/61631668
    static { this.styles = [reset, styles]; }
    /** @internal */
    get _class() {
        return classNames([
            'group block relative break-words last-child:mb-0 p-16 rounded-8',
            this.bleed && '-mx-16 sm:mx-0 rounded-l-0 rounded-r-0 sm:rounded-8',
            this.info && 's-bg-info-subtle',
            this.neutral && 's-surface-sunken',
            this.bordered && 'border-2 s-border s-bg',
        ]);
    }
    /** @internal */
    get _optOutRoleWithDefault() {
        return this.role === '' ? nothing : this.role ?? 'region';
    }
    render() {
        return html `
      <div role="${this._optOutRoleWithDefault}" class="${this._class}">
        <slot></slot>
      </div>
    `;
    }
}
__decorate([
    property({ type: Boolean, reflect: true })
], WarpBox.prototype, "bleed", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpBox.prototype, "bordered", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpBox.prototype, "info", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpBox.prototype, "neutral", void 0);
__decorate([
    property({ type: String, reflect: true })
], WarpBox.prototype, "role", void 0);
if (!customElements.get('w-box')) {
    customElements.define('w-box', WarpBox);
}
export { WarpBox };
//# sourceMappingURL=index.js.map